module.exports = __webpack_public_path__ + "img/header-people.3bc665a1.jpg";